import { Component, Input } from '@angular/core';
import { AccordionItemComponent } from './accordion-item.component';

export type AccordionMode = 'single' | 'multiple';

@Component({
  selector: 'mpf-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
  items: AccordionItemComponent[] = [];
  private _mode: AccordionMode = 'multiple';

  get mode(): AccordionMode {
    return this._mode;
  }

  @Input()
  set mode(value: AccordionMode) {
    if (this._mode === 'multiple' && value === 'single') {
      this.closeAll();
    }

    this._mode = value;
  }

  constructor() {}

  addItem(item: AccordionItemComponent): void {
    this.items.push(item);
  }

  removeItem(item: AccordionItemComponent): void {
    const index = this.items.indexOf(item);

    if (index !== -1) {
      this.items.splice(index, 1);
    }
  }

  closeOthers(openItem: AccordionItemComponent): void {
    if (this._mode === 'single') {
      this.items.forEach(item => {
        if (item !== openItem) {
          item.isOpen = false;
        }
      });
    }
  }

  closeAll(): void {
    this.items.forEach(item => (item.isOpen = false));
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/accordion/accordion.component.ts